export const CURRENT_VISITOR_VID = ['vid'];
export const CONTACTS = ['crmIntegration', 'contacts'];
export const CURRENT_OWNER = ['crmIntegration', 'currentOwner'];
export const requestStatusKeyPathFor = id => ['requestStatus', id];
export const dataKeyPathFor = id => ['data', id];
export const OWNER_BY_USER_ID = ['crmIntegration', 'ownerByUserId'];
export const PORTAL_ID = ['portal-id'];
export const TICKET_DATA = ['crmIntegration', 'ticketData'];
export const TICKET_SOURCES = ['crmIntegration', 'ticketSources'];